export const watchForAttributeChanges = (containerEl: HTMLElement, attribute: string, onChange: () => void) => {
    if (typeof MutationObserver === "undefined") {
        return;
    }

    const isWatchedElement = (node: Node) => node instanceof HTMLElement && node.hasAttribute(attribute);

    const mutation = new MutationObserver((mutationList) => {
        mutationList.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (isWatchedElement(node)) {
                    onChange();
                    return;
                }
            });
        });
    });
    mutation.observe(containerEl, {
        childList: true,
        subtree: true
    });
    return mutation;
};

export const watchForOptions = <T extends HTMLElement>(
    containerEl: HTMLElement,
    tagName: string,
    onChange: (el: T | undefined) => void
) => {
    /* tslint:disable-next-line */
    if (typeof MutationObserver === "undefined") {
        return;
    }

    const mutation = new MutationObserver((mutationList) => {
        onChange(getSelectedOption<T>(mutationList, tagName));
    });
    mutation.observe(containerEl, {
        childList: true,
        subtree: true
    });
    return mutation;
};

const getSelectedOption = <T extends HTMLElement>(mutationList: MutationRecord[], tagName: string): T | undefined => {
    let newOption: HTMLElement | undefined;
    mutationList.forEach((mut) => {
        // eslint-disable-next-line
        for (let i = 0; i < mut.addedNodes.length; i++) {
            newOption = findCheckedOption(mut.addedNodes[i], tagName) || newOption;
        }
    });
    // eslint-disable-next-line
    return newOption as any;
};

// eslint-disable-next-line
const findCheckedOption = (el: any, tagName: string) => {
    if (el.nodeType !== 1) {
        return undefined;
    }
    const options: HTMLElement[] = el.tagName === tagName.toUpperCase() ? [el] : Array.from(el.querySelectorAll(tagName));
    // eslint-disable-next-line
    return options.find((o: any) => o.value === el.value);
};
